import queryString from 'query-string';
import { maskPersonalData } from './hidePersonalData';

const DISPATCH_PAIRS = ['s', 'e', 'l', 'w', 'pn'];

/** Capture once at the Flow boundary, before storage or captcha/network work. */
export function prepareFeedbackSubmission({
  feedback,
  apiUrl,
  submissionId,
  revision = 1,
  isIncomplete = false,
  feedbackId = null,
  version = null,
  search = '',
  launchParams,
  isWidget = false,
  isOnline = true,
  captcha = { required: false, provider: null },
}) {
  // Match the JSON wire representation and keep masking off live answer objects.
  const payload = JSON.parse(JSON.stringify(feedback));
  maskPersonalData(payload);

  payload.created_offline = !isOnline || payload.created_offline === true;
  delete payload.version;
  if (version !== null) payload.version = version;

  const headers = {
    Accept: 'application/json, text/plain, */*',
    'Content-Type': 'application/json',
    'X-COMPLETED': !isIncomplete,
  };

  if (feedbackId) headers['X-FID'] = feedbackId;

  const query = launchParams ?? queryString.parse(search);
  const dispatch = DISPATCH_PAIRS.find((prefix) => query[`${prefix}di`] && query[`${prefix}ci`]);

  if (dispatch) {
    for (const suffix of ['di', 'ci']) {
      headers[`X-${dispatch.toUpperCase()}${suffix.toUpperCase()}`] = query[`${dispatch}${suffix}`];
    }
  } else if (isWidget) {
    headers['X-WWID'] = payload.node_id;
  }

  return {
    submissionId,
    kind: isIncomplete ? 'incomplete' : 'final',
    nodeId: payload.node_id,
    flowId: payload.flow_id,
    apiUrl,
    payload,
    headers,
    feedbackId,
    version,
    revision,

    // Never copy a runtime token into the durable context.
    captcha: { required: captcha.required, provider: captcha.provider ?? null },
  };
}
